import clx from 'classnames';
import type React from 'react';
import Icon from '../../../common/Icon/Icon';
import type { SlideProps } from '../types';
import styles from './Steps.module.css';

interface Props {
    steps: Array<({ nextSlide }: SlideProps) => React.JSX.Element>;
    currentStep: number;
}

const Steps = ({ steps, currentStep }: Props) => (
    <ul className={styles.stepList}>
        {steps.map((_step, index) => {
            const stepComplete = currentStep > index;

            return (
                <li
                    // TODO: Fix eslint index as key error.
                    key={index} // eslint-disable-line react/no-array-index-key
                    className={clx(styles.step, {
                        [styles.stepActive]: currentStep === index,
                        [styles.stepComplete]: stepComplete,
                    })}
                >
                    {stepComplete ? (
                        <Icon
                            icon="check"
                            width={10}
                            height={10}
                            className="motion-safe:animate-drop-fade-in duration-500 delay-500"
                        />
                    ) : (
                        index + 1
                    )}
                </li>
            );
        })}
    </ul>
);

export default Steps;
